import { useEffect } from "react";
import { ensurePublicFonts } from "./fonts";
import "./global.scss";

/** While a public page in the new look shows: its fonts, and a body class that hides today's floating Terms & Privacy button. */
export const usePublicPage = (enabled = true): void => {
  useEffect(() => {
    if (!enabled) return;
    ensurePublicFonts();
    document.body.classList.add("cy-public-page");
    return () => document.body.classList.remove("cy-public-page");
  }, [enabled]);
};
